export default [
  [`Размеры`, `XS`, `S`, `M`, `L`],
  [`Российский размер`, `40`, `42`, `44`, `46`],
  [`Рост`, `170-175`, `170-175`, `170-175`, `170-175`],
  [`Обхват груди(a)`, `80-82`, `84-86`, `88-90`, `92-94`],
  [`Обхват бедер (b)`, `84-88`, `88-92`, `92-96`, `96-100`],
  [`Ширина талии (c)`, `32`, `34`, `36`, `38`],
  [`Ширина бёдер (d)`, `34`, `36`, `38`, `40`],
  [`Длина (с поясом) (e)`, `101`, `102`, `105`, `105`]
];
